// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detailScreen {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
}

.detailScreen-box1 {
  width: 100%;
}

.fixed-header {
  position: fixed;
  top: 90px;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 0px;
  width: 100%;
  max-width: 740px;
  background: #fff;
  z-index: 999;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
@media screen and (max-width: 768px) {
  .fixed-header {
    display: none;
  }
}

.detailScreen-header {
  border: 1px solid rgba(0, 162, 255, 0.0941176471);
  border-radius: 4px;
  padding: 5px;
  background-color: #ecf8ff;
  cursor: pointer;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .detailScreen-header {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 0px;
    z-index: 1000;
    padding: 8px 0px 8px 0px;
    border-top: 1px solid rgb(219, 219, 219);
  }
}

.detailScreen-headerBox {
  display: flex;
  flex-direction: row;
}

.detailScreen-headerBox2 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex: 1 1;
  padding: 0px 10px;
}

.detailScreen-btin1 {
  border-left: 1px solid grey;
}

.detailScreen-btin2 {
  display: flex;
  align-items: center;
  gap: 10px;
  border-left: 1px solid grey;
  padding: 0px 10px;
  font-size: 12px;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .detailScreen-btin2 {
    padding-left: 15px;
    padding-right: 15px;
  }
}

.detailScreen-PreviewBox {
  overflow-x: scroll;
  scroll-behavior: smooth;
  overflow-y: hidden;
  white-space: nowrap;
  margin-top: 10px;
}

.PreviewBox-item {
  display: inline-block;
  vertical-align: middle;
  font-family: "NotoSansMalayalam-SemiBold";
  font-size: 14px;
  margin-right: 20px;
  width: 105px;
  height: 185px;
  overflow: hidden;
  text-align: center;
  border: 1px solid rgb(164, 188, 210);
  cursor: pointer;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .PreviewBox-item {
    margin-right: 20px;
  }
}

.detailScreen-box {
  width: 100%;
  border: 1px solid rgb(164, 188, 210);
  margin-top: 10px;
}

.detailScreen-CropPdf {
  min-height: 70vh;
}

.detailScreen-CropPdfImage2 {
  width: 100%;
}

.detailScreen-CropPdfImage {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media screen and (min-width: 320px) and (max-width: 768px) {
  .detailScreen-txt2 {
    display: none;
  }
}

.PreviewBox-selected {
  padding: 5px;
  font-family: "NotoSansMalayalam-SemiBold";
}
.PreviewBox-selected.active {
  background-color: rgb(5, 118, 183);
  color: #fff;
}

.detailScreen-cropText {
  text-align: center;
  padding: 10px;
  font-family: "NotoSansMalayalam-SemiBold";
  font-size: 16px;
}

.detailScreen-loading {
  height: 50vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.detailScreen-subHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}

.SharePopup {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid rgb(164, 188, 210);
  background-color: #fff;
  min-height: 40vh;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .SharePopup {
    margin: -13px;
    margin-top: 1px;
  }
}

.SharePopup-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 350px;
}

.SharePopup-logo {
  height: 40px;
  object-fit: contain;
  margin-bottom: 10px;
  margin-top: 10px;
}

.SharePopup-img {
  width: 100%;
  max-height: 50vh;
  margin-bottom: 10px;
  object-fit: contain;
}

.SharePopup-txt1 {
  font-size: 12px;
  font-family: "NotoSansMalayalam-Regular";
}

.SharePopup-share {
  display: flex;
  flex-direction: row;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .SharePopup-share {
    margin-left: -13px;
    margin-right: -13px;
  }
}

.SharePopup-icon {
  font-size: 25px;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .SharePopup-icon {
    font-size: 20px;
  }
}

.SharePopup-box {
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid rgba(0, 162, 255, 0.0941176471);
  margin-top: 10px;
  position: relative;
}

.Share-Input {
  display: flex;
  justify-content: center;
  align-items: center;
}

.Share-Icon {
  cursor: pointer;
  padding: 4px;
  border: 1px solid #f2f2f2;
}

.detailScreen-box2 {
  border: 1px solid rgb(209, 209, 209);
  padding: 2px 0px 0px 15px;
  border-radius: 5px;
  font-family: "NotoSansMalayalam-Bold";
  font-size: 14px;
}

.detailScreen-box3 {
  text-align: center;
  font-family: "NotoSansMalayalam-Bold";
  padding: 5px;
}

.detailScreen-croodarea {
  position: absolute;
  border: 2px solid transparent;
  cursor: pointer;
  transition: border-color 0.3s ease;
}
.detailScreen-croodarea:hover {
  border: 2px dashed rgb(12, 102, 228);
  background-color: rgba(63, 116, 169, 0.293);
}

.detailScreen-imageContainer {
  position: relative;
}
.detailScreen-imageContainer img {
  display: block;
  max-width: 100%;
  height: auto;
}

.detailScreen-arrow-leftBox {
  height: 80vh;
  display: flex;
  align-items: center;
  padding-left: 10px;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .detailScreen-arrow-leftBox {
    display: none;
  }
}

.detailScreen-arrow-rightBox {
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .detailScreen-arrow-rightBox {
    display: none;
  }
}

.fixed-arrow {
  position: fixed;
  top: 170px;
  left: 20px;
  z-index: 998;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .fixed-arrow {
    display: none;
  }
}

.fixed-arrow-right {
  position: fixed;
  top: 170px;
  right: 20px;
  z-index: 998;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .fixed-arrow-right {
    display: none;
  }
}

.detailScreen-arrow-left {
  background-color: #ecf8ff;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
}

.detailScreen-ZoomPopup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.587);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 12000;
}

.detailScreen-zoomimage {
  width: 100vw;
  height: 100vh;
  object-fit: contain;
}

.detailScreen-ZoomHeader {
  margin-bottom: 2px;
  color: #fff;
  position: fixed;
  bottom: 10px;
  left: 0;
  right: 0;
}

.detailScreen-ZoomHeader2 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.detailScreen-zoomControl {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 100px;
  padding: 15px 30px;
  border-radius: 100px;
  background-color: rgba(0, 0, 0, 0.8117647059);
  cursor: pointer;
}

.detailScreen-zoomclose {
  margin-bottom: 2px;
  color: #fff;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 20px;
  cursor: pointer;
  z-index: 2000;
}

.SharePopup-img-container {
  position: relative;
  display: inline-block;
}

.zoom-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.8117647059);
  border-radius: 100px;
  padding: 10px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  color: #fff;
}

.detailScreen-zoomcloseIcon {
  background: rgba(0, 0, 0, 0.8117647059);
  border-radius: 100px;
  padding: 10px;
}`, "",{"version":3,"sources":["webpack://./src/screens/detailScreen/styles.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AACA;EACE,eAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,wCAAA;AAEF;AACE;EAbF;IAcI,aAAA;EAEF;AACF;;AAGA;EACE,iDAAA;EAEA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;AADF;AAGE;EARF;IASI,eAAA;IACA,SAAA;IACA,OAAA;IACA,QAAA;IACA,kBAAA;IACA,aAAA;IACA,wBAAA;IACA,wCAAA;EAAF;AACF;;AAGA;EACE,aAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;AAAF;;AAGA;EACE,2BAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;EACA,iBAAA;EACA,eAAA;AAAF;AACE;EAPF;IAQI,kBAAA;IACA,mBAAA;EAEF;AACF;;AACA;EACE,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAEF;;AACA;EACE,qBAAA;EACA,sBAAA;EACA,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,eAAA;AAEF;AADE;EAZF;IAaI,kBAAA;EAIF;AACF;;AADA;EACE,WAAA;EACA,oCAAA;EACA,gBAAA;AAIF;;AADA;EACE,gBAAA;AAIF;;AADA;EACE,WAAA;AAIF;;AADA;EAEE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAGF;;AACE;EADF;IAEI,aAAA;EAGF;AACF;;AAAA;EACE,YAAA;EACA,yCAAA;AAGF;AAFE;EACE,kCAAA;EACA,WAAA;AAIJ;;AAAA;EACE,kBAAA;EACA,aAAA;EACA,yCAAA;EACA,eAAA;AAGF;;AAAA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAGF;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAGF;;AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,sBAAA;EACA,gBAAA;AAGF;AAFE;EARF;IASI,aAAA;IACA,eAAA;EAKF;AACF;;AAFA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAKF;;AAFA;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAKF;;AAFA;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAKF;;AAFA;EACE,eAAA;EACA,wCAAA;AAKF;;AAFA;EACE,aAAA;EACA,mBAAA;AAKF;AAHE;EAJF;IAKI,kBAAA;IACA,mBAAA;EAMF;AACF;;AAHA;EACE,eAAA;AAMF;AAJE;EAHF;IAII,eAAA;EAOF;AACF;;AAJA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iDAAA;EACA,gBAAA;EACA,kBAAA;AAOF;;AALA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAQF;;AALA;EACE,eAAA;EACA,YAAA;EACA,yBAAA;AAQF;;AALA;EACE,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,qCAAA;EACA,eAAA;AAQF;;AALA;EACE,kBAAA;EACA,qCAAA;EACA,YAAA;AAQF;;AALA;EACE,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,kCAAA;AAQF;AANE;EACE,oCAAA;EACA,2CAAA;AAQJ;;AAJA;EACE,kBAAA;AAOF;AANE;EACE,cAAA;EACA,eAAA;EACA,YAAA;AAQJ;;AAJA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAOF;AANE;EALF;IAMI,aAAA;EASF;AACF;;AANA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AASF;AARE;EANF;IAOI,aAAA;EAWF;AACF;;AATA;EACE,eAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;AAYF;AAVE;EANF;IAOI,aAAA;EAaF;AACF;;AAXA;EACE,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AAcF;AAZE;EANF;IAOI,aAAA;EAeF;AACF;;AAZA;EACE,yBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAeF;;AAVA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAaF;;AAVA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AAaF;;AAVA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;AAaF;;AAVA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AAaF;;AAVA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,6CAAA;EACA,eAAA;AAaF;;AAVA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;AAaF;;AAVA;EACE,kBAAA;EACA,qBAAA;AAaF;;AAVA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,uCAAA;EACA,oBAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AAaF;;AAVA;EACE,uCAAA;EACA,oBAAA;EACA,aAAA;AAaF","sourcesContent":[".detailScreen {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: row;\n}\n\n.detailScreen-box1 {\n  width: 100%;\n}\n.fixed-header {\n  position: fixed;\n  top: 90px;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-top: 0px;\n  width: 100%;\n  max-width: 740px;\n  background: #fff;\n  z-index: 999;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n  // Hide on mobile\n  @media screen and (max-width: 768px) {\n    display: none;\n  }\n}\n\n\n\n.detailScreen-header {\n  border: 1px solid #00a2ff18;\n  // margin-top: 10px;\n  border-radius: 4px;\n  padding: 5px;\n  background-color: #ecf8ff;\n  cursor: pointer;\n\n  @media screen and (min-width: 320px) and (max-width: 768px) {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    border-radius: 0px;\n    z-index: 1000;\n    padding: 8px 0px 8px 0px;\n    border-top: 1px solid rgb(219, 219, 219);\n  }\n}\n\n.detailScreen-headerBox {\n  display: flex;\n  flex-direction: row;\n}\n\n.detailScreen-headerBox2 {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  flex: 1;\n  padding: 0px 10px;\n}\n\n.detailScreen-btin1 {\n  border-left: 1px solid grey;\n}\n\n.detailScreen-btin2 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  border-left: 1px solid grey;\n  padding: 0px 10px;\n  font-size: 12px;\n  @media screen and (min-width: 320px) and (max-width: 768px) {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n}\n\n.detailScreen-PreviewBox {\n  overflow-x: scroll;\n  scroll-behavior: smooth;\n  overflow-y: hidden;\n  white-space: nowrap;\n  margin-top: 10px;\n}\n\n.PreviewBox-item {\n  display: inline-block;\n  vertical-align: middle;\n  font-family: \"NotoSansMalayalam-SemiBold\";\n  font-size: 14px;\n  margin-right: 20px;\n  width: 105px;\n  height: 185px;\n  overflow: hidden;\n  text-align: center;\n  border: 1px solid rgb(164, 188, 210);\n  cursor: pointer;\n  @media screen and (min-width: 320px) and (max-width: 768px) {\n    margin-right: 20px;\n  }\n}\n\n.detailScreen-box {\n  width: 100%;\n  border: 1px solid rgb(164, 188, 210);\n  margin-top: 10px;\n}\n\n.detailScreen-CropPdf {\n  min-height: 70vh;\n}\n\n.detailScreen-CropPdfImage2 {\n  width: 100%;\n}\n\n.detailScreen-CropPdfImage {\n  // width: 100%;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.detailScreen-txt2 {\n  @media screen and (min-width: 320px) and (max-width: 768px) {\n    display: none;\n  }\n}\n\n.PreviewBox-selected {\n  padding: 5px;\n  font-family: \"NotoSansMalayalam-SemiBold\";\n  &.active {\n    background-color: rgb(5, 118, 183);\n    color: #fff;\n  }\n}\n\n.detailScreen-cropText {\n  text-align: center;\n  padding: 10px;\n  font-family: \"NotoSansMalayalam-SemiBold\";\n  font-size: 16px;\n}\n\n.detailScreen-loading {\n  height: 50vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.detailScreen-subHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n\n.SharePopup {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgb(164, 188, 210);\n  background-color: #fff;\n  min-height: 40vh;\n  @media screen and (min-width: 320px) and (max-width: 768px) {\n    margin: -13px;\n    margin-top: 1px;\n  }\n}\n\n.SharePopup-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 350px;\n}\n\n.SharePopup-logo {\n  height: 40px;\n  object-fit: contain;\n  margin-bottom: 10px;\n  margin-top: 10px;\n}\n\n.SharePopup-img {\n  width: 100%;\n  max-height: 50vh;\n  margin-bottom: 10px;\n  object-fit: contain;\n}\n\n.SharePopup-txt1 {\n  font-size: 12px;\n  font-family: \"NotoSansMalayalam-Regular\";\n}\n\n.SharePopup-share {\n  display: flex;\n  flex-direction: row;\n\n  @media screen and (min-width: 320px) and (max-width: 768px) {\n    margin-left: -13px;\n    margin-right: -13px;\n  }\n}\n\n.SharePopup-icon {\n  font-size: 25px;\n\n  @media screen and (min-width: 320px) and (max-width: 768px) {\n    font-size: 20px;\n  }\n}\n\n.SharePopup-box {\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border: 1px solid #00a2ff18;\n  margin-top: 10px;\n  position: relative;\n}\n.Share-Input {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.Share-Icon {\n  cursor: pointer;\n  padding: 4px;\n  border: 1px solid #f2f2f2;\n}\n\n.detailScreen-box2 {\n  border: 1px solid rgb(209, 209, 209);\n  padding: 2px 0px 0px 15px;\n  border-radius: 5px;\n  font-family: \"NotoSansMalayalam-Bold\";\n  font-size: 14px;\n}\n\n.detailScreen-box3 {\n  text-align: center;\n  font-family: \"NotoSansMalayalam-Bold\";\n  padding: 5px;\n}\n\n.detailScreen-croodarea {\n  position: absolute;\n  border: 2px solid transparent;\n  cursor: pointer;\n  transition: border-color 0.3s ease;\n\n  &:hover {\n    border: 2px dashed rgb(12, 102, 228);\n    background-color: rgba(63, 116, 169, 0.293);\n  }\n}\n\n.detailScreen-imageContainer {\n  position: relative;\n  img {\n    display: block;\n    max-width: 100%;\n    height: auto;\n  }\n}\n\n.detailScreen-arrow-leftBox {\n  height: 80vh;\n  display: flex;\n  align-items: center;\n  padding-left: 10px;\n  @media screen and (min-width: 320px) and (max-width: 768px) {\n    display: none;\n  }\n}\n\n.detailScreen-arrow-rightBox {\n  height: 80vh;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding-right: 10px;\n  @media screen and (min-width: 320px) and (max-width: 768px) {\n    display: none;\n  }\n}\n.fixed-arrow {\n  position: fixed;\n  top: 170px; // adjust as needed based on your layout\n  left: 20px;\n  z-index: 998;\n\n  @media screen and (min-width: 320px) and (max-width: 768px) {\n    display: none;\n  }\n}\n.fixed-arrow-right{\n  position: fixed;\n  top: 170px; // adjust as needed based on your layout\n  right: 20px;\n  z-index: 998;\n\n  @media screen and (min-width: 320px) and (max-width: 768px) {\n    display: none;\n  }\n}\n\n.detailScreen-arrow-left {\n  background-color: #ecf8ff;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #000;\n}\n\n//--------------------\n\n.detailScreen-ZoomPopup {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.587);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 12000;\n}\n\n.detailScreen-zoomimage {\n  width: 100vw;\n  height: 100vh;\n  object-fit: contain;\n}\n\n.detailScreen-ZoomHeader {\n  margin-bottom: 2px;\n  color: #fff;\n  position: fixed;\n  bottom: 10px;\n  left: 0;\n  right: 0;\n}\n\n.detailScreen-ZoomHeader2 {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.detailScreen-zoomControl {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  gap: 100px;\n  padding: 15px 30px;\n  border-radius: 100px;\n  background-color: #000000cf;\n  cursor: pointer;\n}\n\n.detailScreen-zoomclose {\n  margin-bottom: 2px;\n  color: #fff;\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 20px;\n  cursor: pointer;\n  z-index: 2000;\n}\n\n.SharePopup-img-container {\n  position: relative;\n  display: inline-block;\n}\n\n.zoom-icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: #000000cf;\n  border-radius: 100px;\n  padding: 10px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  color: #fff;\n}\n\n.detailScreen-zoomcloseIcon {\n  background: #000000cf;\n  border-radius: 100px;\n  padding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
